<template>
  <div class="result_outer">
    <div class="result_container">
      <div class="desc">
        <p><img :src="successImg" alt="successImg"><span>
                        {{ (activityModel.payStatus === '未付款' || activityModel.payStatus ===
                            '已退费') ? 'One more step! Please make the payment!' : activityModel.signStatus === '已报名' ? 'Congratulations, you have registered successfully' : '' }}
                    </span>
        </p>
        <ul class="sign_list">
          <li>
            <label>Registration Number</label><span>{{ activityModel.activitySignModel &&
                            activityModel.activitySignModel.activitySignCode ?
                            activityModel.activitySignModel.activitySignCode : '--' }}</span>
          </li>
          <li><label>Event Name</label><a href="javascript:void(0)" @click="goToActivityDetail"><span>{{
                        activityModel.activityName }}</span><img :src="rightImg" alt="rightImg"></a></li>
          <li>
            <label>Fee</label>
            <span v-if="activityModel.activityFee>0 && activityModel.activityId !== malaysiaActivityId">
                            <!-- <span style="color: red;">CNY {{ activityModel.activityFee }}</span> -->
                            <!-- <span style="color: #ccc;" v-if="activityModel.currency && activityModel.currencyAmount">| </span > -->
                            <span style="color: red;" v-if="activityModel.currency && activityModel.currencyAmount">{{activityModel.currency+' '+ moneyFormat(activityModel.currencyAmount)}}</span>
                            <span style="color: red;" v-else>CNY {{moneyFormat(activityModel.activityFee)}}</span>
                        </span>
            <span style="color: red;" v-else-if="activityModel.activityFee>0 && activityModel.activityId === malaysiaActivityId">MYR {{moneyFormat(activityModel.currencyAmount)}}</span>
            <span v-else>free</span>
          </li>
          <li v-if="activityModel.payStatus === '已付款'">
            <label>Final cost</label>
            <span style="color: red;">{{activityModel.activitySignModel.payCurrency || ''}}{{activityModel.activitySignModel.payCurrencyAmount?moneyFormat(activityModel.activitySignModel.payCurrencyAmount):0}}</span>
          </li>
          <li>
            <label>Date</label><span>{{ activityModel.activityStar }}<br />{{ activityModel.activityEnd
                        }}</span>
          </li>
           <li v-if="activityModel.payStatus === '已付款'">
            <label>Payment time</label>
            <span >{{ activityModel.activitySignModel.payDate }}</span>
          </li>
          <li><label>Location</label><span>{{ activityModel.address }}</span></li>
        </ul>
      </div>
      <div class="linkman">
        <span></span>
        <span></span>
        <ul class="sign_list">
          <li>
            <label>Registrant</label>
            <div>
              <strong>{{ activityModel.activitySignModel && activityModel.activitySignModel.signContactName ?
                activityModel.activitySignModel.signContactName : '--' }}</strong><span></span><span>+{{ activityModel.activitySignModel.signContactMobileAreaCode }}-{{
        activityModel.activitySignModel && activityModel.activitySignModel.signContactMobile ?
        activityModel.activitySignModel.signContactMobile : '--' }}</span>
            </div>
          </li>
          <li>
            <label>Contact Person</label>
            <div>
              <strong>{{ activityModel.contactsName }}</strong>
              <a class="link_color" :href="'tel:00' +activityModel.contactsPhoneAreaCode + activityModel.contactsPhone">
              +{{ activityModel.contactsPhoneAreaCode }}-{{ activityModel.contactsPhone }}</a>
            </div>
          </li>
        </ul>
      </div>
      <div class="success-info" v-if="activityModel.signStatus === '已报名'&&activityModel.payStatus == '已付款'">
        <span><img :src="iconInfoImg" alt="iconInfoImg"></span>
        <p>This is your registration confirmation page. Please take a screenshot. More event details will be emailed to you with the payment confirmation。</p>
      </div>
    </div>
    <div class="footer_sign_result df">
      <span class="font-blod">{{(activityModel.activityId === malaysiaActivityId?'MYR ':(activityModel.currency?(activityModel.currency+' '):'￥ '))+ moneyFormat(activityModel.currencyAmount) }}</span>
      <button class="df1" @click="payFun">{{
        (activityModel.payStatus === '未付款' || activityModel.payStatus === '已退费') ? 'Pay' :
        activityModel.signStatus === '已报名' ? 'Registered' : ' Click to Register'
        }}
      </button>
    </div>
  </div>
</template>

<script>
  import rightIcon from '@/assets/channelNew/goRight.png'
  import successIcon from '@/assets/channelNew/iconGouBlue.png'
  import customerService from '@/api/customerService'
  import Common from "../utils/common";
  import { Indicator } from 'mint-ui';
  import iconInfo from '@/assets/channelNew/info.png'
  import { moneyFormat} from "@/utils/utils";
  import $ from "jquery";

  export default {
    name: "signResult",
    data() {
      return {
        activitySignModel: {},
        rightImg: rightIcon,
        successImg: successIcon,
        activityModel: {},
        activityId: '',
        channelId: '',
        activitySignId: '',
        type: '',
        payIng: false,
        prodActivityIds: ["dec09095206b48bbbfc5125e4fc1d66b", "c535ac8517ec446d9fbe7b1504aeed42", "e90025ce1fa64c318566596c21339ac6",
          "08c2d26c69164be19bff9a1d320bdb43", "ac4e6d5d49e9434ab051b65fa6899dd0",
          "a89319f0b8004fb594cb13484d6eca02",
          "357533f8aa8c4cfb8ef8824e3f2e9c40",
          "bd37ab7f7a014a5cb9c022c4849248f5",
          "b6e18fdb7c314e548612298825b8fb0f",
          "ba4f45687e96478ba7e7514c3a994d1f",
          "e97cf6d102f74ce5bb5f0a399e1fdce0",
        ],
        testActivityIds: [
          "481ac0606dab4d4db2b9863c7c8c6300",
          "08f6204c87644b3096b6f03ec5f7d201",
          "985be476980f4baf8343fc46529fe2ea",
          "2df888d25d2a45cd8a59c3f5af185bc4",
          "68f0bee2925743caaa64f65116f28dcc",
        ],
        malaysiaActivityId:customerService.MalaysiaActivityId,
        iconInfoImg:iconInfo,
        moneyFormat:moneyFormat,
          tt_test_id: '',
      }
    },
    mounted() {
      var vm = this;
      document.title = 'Registration Details';
        //广告Id
        if (vm.$route.query.tt_test_id) {
            vm.tt_test_id = vm.$route.query.tt_test_id;
            $.cookie('tt_test_id',vm.tt_test_id)
        }else{
            vm.tt_test_id =  $.cookie('tt_test_id');
            $.cookie('tt_test_id','')
        }
      vm.activityId = vm.$route.query.activityId;
      vm.activitySignId = vm.$route.query.activitySignId;
      vm.type = vm.$route.query.type;
      if (vm.$route.query.channelId && vm.$route.query.channelId != 'null') {
        vm.channelId = vm.$route.query.channelId;
        this.getNewLinkContactsDetail()
      } else {
        this.getResultDetail();
      }
    },
    methods: {
        //开始结账（广告统计）
        InitiateCheckout() {
            var vm = this;
            ttq.track('InitiateCheckout', {
                contents: [
                    {
                        content_id: vm.channelId,
                        content_name: vm.activityModel.activityName,
                        price: vm.activityModel.activityFee,
                        quantity: 1,
                    }
                ],
                currency: vm.activityModel.currency,
                content_type: 'product',
                value: vm.activityModel.activityFee,
                quantity: 1,
            })
        },
        //支付完成（广告统计）
        completePayment() {
            var vm = this;
            ttq.track('CompletePayment', {
                contents: [
                    {
                        content_id: vm.channelId,
                        content_name: vm.activityModel.activityName,
                        price: vm.activityModel.activityFee,
                        quantity: 1,
                    }
                ],
                currency: vm.activityModel.currency,
                content_type: 'product',
                value: vm.activityModel.activityFee,
                quantity: 1,
            })
        },
      getResultDetail() {
        var vm = this;
        var url = window.location.href;
        customerService.getChannelActivityDetail(vm, vm.activityId, vm.type, vm.activitySignId).then(function (data) {
          vm.activityModel = data;
          // if(url.includes('//erp.bosum.com/customerActivity/')){
          //   if(vm.prodActivityIds.includes(vm.activityId)){
          //     if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
          //       Indicator.open('支付中...');
          //       vm.getResultDetail()
          //     }else{
          //       Indicator.close();
          //     }
          //   }
          // }else{
          //   if(vm.testActivityIds.includes(vm.activityId)){
          //     if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
          //       vm.getResultDetail()
          //     }else{
          //       Indicator.close();
          //     }
          //   }
          // }
          if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
            vm.getResultDetail()
          }else{
            Indicator.close();
          }
        });
      },
      getNewLinkContactsDetail() {
        var vm = this;
        var url = window.location.href;
        customerService.getNewLinkContactsDetail(vm, vm.channelId, vm.activitySignId,vm.$route.query.payType).then(function (data) {
          vm.activityModel = data;
          // if(url.includes('//erp.bosum.com/customerActivity/')){
          //   if(vm.prodActivityIds.includes(vm.activityId)){
          //     if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
          //       Indicator.open('支付中...');
          //       vm.getNewLinkContactsDetail()
          //     }else{
          //       Indicator.close();
          //     }
          //   }
          // }else{
          //   if(vm.testActivityIds.includes(vm.activityId)){
          //     if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
          //       vm.getNewLinkContactsDetail()
          //     }else{
          //       Indicator.close();
          //     }
          //   }
          // }
            if(vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'&&vm.tt_test_id){
                vm.completePayment();
            }
          if(vm.activityModel.payStatus == '未付款'&&vm.activityModel.signStatus == '已报名'&&vm.$route.query.payType=='Y'){
            Indicator.open('Paying...');
            vm.getNewLinkContactsDetail()
          }else{
            Indicator.close();
          }
        });
      },
      goToActivityDetail() {
        var vm = this;
        vm.$router.push({ path: '/channelDetail', query: { activityId: vm.activityId, channelId: vm.channelId, type: vm.type } });
      },
      payFun: function () {
        var vm = this;
          if (vm.tt_test_id) {
              vm.InitiateCheckout();
          }
        if (vm.activityModel.payStatus === '未付款' || vm.activityModel.payStatus === '已退费') {
          if (vm.payIng) {
            Common.PageOperator.showPromptMsg(vm, true, 'Paying...', 'warning');
            return;
          }
          // if(vm.activityModel.currency=='IDR'){
          //   vm.mptPayFun(vm.activitySignId)
          //   return
          // }
          vm.payIng = true;
          customerService.stripePay(vm, vm.activitySignId,vm.channelId).then(function (data) {
            vm.payIng = false;
            window.location.href = data;
          });
        } else if (vm.activityModel.signStatus === '未报名') {
          vm.$router.push({ path: '/channelDetail', query: { activityId: vm.activityId, type: vm.type } });
        }
      },
      // mpt支付
      // mptPayFun(activitySignId){
      //   var vm = this;
      //   customerService.mptStripePay(vm,activitySignId).then(function (data){
      //     window.location.href = data;
      //   });
      // },
    }
  }
</script>

<style scoped>
  .result_outer {
    background: #eee;
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .result_container {
    background-color: #f6f6f6;
    height: 100vh;
    padding: 20px;
    max-width: 500px;
    margin: 0 auto;
  }

  .desc {
    background: #fff;
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .desc>p {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #59a5f1;
    width: 80%;
    margin: 0 auto 10px;
  }

  .desc>p>img {
    width: 20px;
    margin-right: 5px;
  }

  .sign_list {
    padding: 0 15px;
  }

  .sign_list>li {
    padding: 12px 0;
    display: flex;
  }

  .sign_list>li>label {
    width: 90px;
    font-weight: normal;
    color: #666;
  }

  .sign_list>li>span {
    font-weight: bold;
  }

  .sign_list>li>div>img,
  .sign_list>li>a>img {
    width: 7px;
    height: 14px;
    margin-left: 5px;
  }

  .sign_list>li>div,
  .sign_list>li>a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 90px);
  }

  .sign_list>li>a {
    color: #000;
  }

  .linkman {
    background: #fff;
    border-top: 1px dashed #e0e0e0;
    padding-top: 10px;
    position: relative;
  }

  .linkman>span {
    position: absolute;
    top: -8px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #f1f1f1;
  }

  .linkman>span:first-child {
    left: -7px;
  }

  .linkman>span:nth-child(2) {
    right: -7px;
  }

  .link_color {
    color: rgb(90, 167, 242);
  }

  .footer_sign_result {
    bottom: 0;
    right: 0;
    left: 0;
    min-height: 50px;
    width: 100%;
    position: fixed;
  }

  .footer_sign_result>span {
    min-width: 120px;
    padding: 0 2px;
    color: #d43d3d;
    line-height: 50px;
    text-align: center;
    background-color: #ffffff;
  }

  .footer_sign_result>button {
    height: 50px;
    background-color: #d43d3d;
    color: #fff;
    border: none;
    font-size: 16px;
  }
  .success-info{
    display: flex;
    color: #666;
    margin-top: 10px;
  }
  .success-info img{
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/signResult.vue